import { getExeVersions } from '../../Constant';

const VersionSelector = ({ version, setVersion }) => {
  return (
    <div className="d-flex align-items-start" style={{ gap: '0.8rem' }}>
      <div className="fillSelect">
        <i className="mdi mdi-source-branch font-20 fillIcon"></i>

        <select
          className="form-control font-14"
          name="projectIds"
          value={version}
          onChange={(e) => setVersion(e.target.value)}
        >
          {getExeVersions()?.map((v) => (
            <option value={v.value}>{v.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default VersionSelector;
